import { render } from "./DetalleVentas.vue?vue&type=template&id=3116bbf1"
import script from "./DetalleVentas.vue?vue&type=script&lang=js"
export * from "./DetalleVentas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__